/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationContextResponseEnterpriseCompanyMostActiveMembers } from './';
import {
    InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSON,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSONTyped,
    InvitationContextResponseEnterpriseCompanyMostActiveMembersToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseCompany
 */
export interface InvitationContextResponseEnterpriseCompany {
    /**
     * 
     * @type {InvitationContextResponseEnterpriseCompanyMostActiveMembers}
     * @memberof InvitationContextResponseEnterpriseCompany
     */
    mostActiveMembers?: InvitationContextResponseEnterpriseCompanyMostActiveMembers;
    /**
     * the number of other members the company
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseCompany
     */
    nbOtherMembers?: number;
    /**
     * the name of the company
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseCompany
     */
    name?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseCompany interface.
 */
export function instanceOfInvitationContextResponseEnterpriseCompany(value: object): value is InvitationContextResponseEnterpriseCompany {
    return true;
}

export function InvitationContextResponseEnterpriseCompanyFromJSON(json: any): InvitationContextResponseEnterpriseCompany {
    return InvitationContextResponseEnterpriseCompanyFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'mostActiveMembers': json['mostActiveMembers'] == null ? undefined : InvitationContextResponseEnterpriseCompanyMostActiveMembersFromJSON(json['mostActiveMembers']),
        'nbOtherMembers': json['nbOtherMembers'] == null ? undefined : json['nbOtherMembers'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InvitationContextResponseEnterpriseCompanyToJSON(value?: InvitationContextResponseEnterpriseCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mostActiveMembers': InvitationContextResponseEnterpriseCompanyMostActiveMembersToJSON(value['mostActiveMembers']),
        'nbOtherMembers': value['nbOtherMembers'],
        'name': value['name'],
    };
}

